module.exports = __webpack_public_path__ + "img/help-video.7b972b4b.svg";